/**
 * Constantes centralizadas para Analytics (GTM/GA4)
 * 
 * BUENAS PRÁCTICAS:
 * - Módulos: Basados en lógica de negocio, no en estructura de carpetas
 * - Secciones: Enfoque híbrido (funcionalidad genérica + componente específico cuando necesario)
 * - Valores: Siempre strings estables y predefinidos (NO IDs, timestamps ni textos dinámicos)
 */

// Módulos basados en lógica de negocio
export const ANALYTICS_MODULES = {
  LANDING: 'landing',
  PRODUCTOS: 'productos',
  COTIZACION: 'cotizacion',
};

// Secciones - Enfoque híbrido (funcionalidad + componente cuando necesario)
export const ANALYTICS_SECTIONS = {
  // Funcionalidades genéricas
  MAIN: 'main',
  
  // Específicas por módulo (cuando el componente es relevante para análisis)
  // Landing
  LANDING_HEADER: 'landing_header',
  LANDING_PRODUCTS: 'landing_products',
  LANDING_WELCOME: 'landing_welcome',
  LANDING_CAROUSEL: 'landing_carousel',
  LANDING_FOOTER: 'landing_footer',
  
  // Productos
  PRODUCTS_MAIN: 'products_main',
  
  // Cotización
  QUOTATION_FORM: 'quotation_form',
  QUOTATION_RESPONSE_SUCCESS: 'quotation_response_success',
  QUOTATION_RESPONSE_ERROR: 'quotation_response_error',

};

// Tipos de elementos para tracking
// Usar estas constantes en lugar de strings hardcodeados en getElementName()
export const ANALYTICS_ELEMENT_TYPES = {
  BUTTON: 'button',
  ICON: 'icon',
  LINK: 'link',
  CARD: 'card',
  RADIO: 'radio',
  CHECKBOX: 'checkbox',
  TAB: 'tab',
  INPUT: 'input',
  DROPDOWN: 'dropdown',
  IMAGE: 'image'
};

// Valores de acción predefinidos para tracking
// Usar estas constantes en lugar de strings hardcodeados en getElementName()
export const ANALYTICS_ACTIONS = {
  // Acciones de cobertura

};


